import { Routes } from '@angular/router';

// Guards (Serão atualizados futuramente para authGuard do Keycloak)
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';

import { IndicatorsDashboard } from './modules/indicadores/indicators-dashboard/indicators-dashboard';
import { IndicatorEditComponent } from './modules/indicadores/indicator-edit/indicator-edit';
import { CollectionDashboard } from './modules/coletas/collection-dashboard/collection-dashboard';
import { AnalyticsDashboard } from './modules/analytics/analytics-dashboard/analytics-dashboard';
import { VotacaoFotografiasComponent } from './modules/concurso-fotografias/votacao/votacao';
import { AdministracaoFotografiasComponent } from './modules/concurso-fotografias/administracao/administracao';

export const routes: Routes = [
  { path: 'indicadores', component: IndicatorsDashboard, canActivate: [authGuard, adminGuard] },
  { path: 'indicadores/novo', component: IndicatorEditComponent, canActivate: [authGuard, adminGuard] },
  { path: 'indicadores/:id/editar', component: IndicatorEditComponent, canActivate: [authGuard, adminGuard] },
  { path: 'analytics', component: AnalyticsDashboard, canActivate: [authGuard, adminGuard] },
  { path: 'coletas', component: CollectionDashboard, canActivate: [authGuard] },
  { path: 'concurso-fotografias', component: VotacaoFotografiasComponent, canActivate: [authGuard] },
  { path: 'concurso-fotografias/admin', component: AdministracaoFotografiasComponent, canActivate: [authGuard, adminGuard] },
  { path: 'CONCURSO-FOTOGRAFIAS', redirectTo: 'concurso-fotografias', pathMatch: 'full' },
  { path: 'CONCURSO-FOTOGRAFIAS/ADMIN', redirectTo: 'concurso-fotografias/admin', pathMatch: 'full' },
  { path: '', pathMatch: 'full', redirectTo: 'coletas' },
  { path: '**', redirectTo: 'coletas' },
];

